import styled from 'styled-components';
import CircleFrame from '@public/circle-frame.svg';
import { breakpoints } from '@theme/breakpoints';

export const StyledBundleInfoNavigator = styled.section`
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }

  scroll-behavior: smooth;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: var(--font-geomanist);
  text-align: center;
  margin-top: 8rem;

  & h2 {
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    text-align: center;
    color: var(--color-primary);

    @media ${breakpoints.tablet} {
      font-size: 26px;
    }

    @media ${breakpoints.desktop} {
      font-size: 34px;
    }
  }

  .circle-items-container {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%;
    padding: 2rem 1rem 3rem 1rem;

    .circle {
      background: linear-gradient(to right, #0402fd 0%, #f4111b 100%);
      width: 100%;
      color: white;
      padding: 0.3rem;
      border-radius: 8px;
    }

    @media ${breakpoints.tablet} {
      padding: 4rem 2rem;
      flex-direction: row;
      gap: 2rem;

      .circle {
        position: relative;
        width: 200px;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #0033cc;
        font-weight: 700;
        font-size: 25px;
        line-height: 28px;
        cursor: pointer;
        background: transparent;

        & span {
          width: 85%;
        }
      }

      .circle::before {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url('${CircleFrame.src}');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        z-index: -1;
      }

      .circle:hover::before {
        animation: pulse 1s infinite ease-in-out;
      }
    }
  }

  .info-items-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 2rem;

    .info-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      @media ${breakpoints.tablet} {
        margin-bottom: 5rem;

        &:last-child {
          margin-bottom: 2rem;
        }
      }

      .info {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        text-align: left;

        @media ${breakpoints.tablet} {
          width: 50%;
          padding-right: 2rem;
        }

        & h3 {
          font-family: Geomanist;
          font-weight: 700;
          font-size: 27px;
          line-height: 26px;
          letter-spacing: 0;
          vertical-align: middle;
          background-size: 200% auto;
          background: linear-gradient(90deg, #0402fc 0%, #0402fd 0%, #f4111b 55%, #f4111b 100%) left
            center;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;

          @media ${breakpoints.tablet} {
            font-size: 22px;
            line-height: 22px;
          }
          @media ${breakpoints.desktop} {
            font-size: 42px;
            line-height: 42px;
          }
        }

        & h4 {
          font-family: Geomanist;
          font-weight: 500;
          font-size: 19px;
          line-height: 26px;
          color: var(--color-primary);

          @media ${breakpoints.tablet} {
            font-size: 18px;
            line-height: 22px;
          }
          @media ${breakpoints.desktop} {
            font-size: 32px;
            line-height: 42px;
          }
        }

        & p {
          font-family: Roboto;
          font-weight: 200;
          font-size: 16px;
          line-height: 24px;
          color: black !important;

          @media ${breakpoints.tablet} {
            font-size: 14px;
            line-height: 22px;
          }
          @media ${breakpoints.desktop} {
            font-size: 18px;
            line-height: 28px;
          }

          & strong {
            color: black !important;
            font-weight: 700 !important;
          }
        }

        & p + p,
        ul {
          margin-top: 2rem;
        }

        & ol {
          list-style-type: decimal;
          padding-left: 18px;
          padding-top: 5px;
        }

        .faqs-container {
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          gap: 20px;
          flex-wrap: nowrap;

          @media ${breakpoints.desktopLarge} {
            margin-right: 5rem;
          }

          & button {
            color: black !important;
            padding-right: 10px;
          }

          & ul {
            line-height: 24px;
            list-style-type: disc;
            padding-inline-start: 20px;
            font-weight: 200;
            padding-bottom: 20px;
          }
        }
      }

      .image {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3rem 0;
        height: 320px;
        width: 100%;
        max-height: 320px;
        overflow: hidden;

        @media ${breakpoints.tablet} {
          padding: 2rem;
          width: 50%;
          height: 100%;
          max-height: 420px;
        }

        & > span {
          position: relative !important;
          height: 100% !important;
          width: 100% !important;
        }

        img {
          object-fit: cover !important;
        }
      }
    }

    @media ${breakpoints.tablet} {
      gap: 2rem;

      .info-item:nth-child(even) {
        flex-direction: row-reverse;

        .info {
          padding-left: 1.5rem;
        }
        .image {
          padding-left: 0;
        }
      }

      .info-item:nth-child(odd) {
        flex-direction: row;
      }
    }
  }
`;
